import {login} from "./auth"
import { baseUrl } from "./consts"
import { coursRoutes } from "./apiRoutes"

export async function getCour({region,id}) {
  console.log(region)
  console.log(id)
    const response=await login();
if (response.ok) {
    var data = await response.json();
    console.log(data)
    const res = await fetch(`${baseUrl}${coursRoutes.filter(x=>x.region===region)[0].url}/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization":"Bearer "+data['access_token']
      },
      
    });

    const json = await res.json();
  
    if (json.errors) {
      console.error(json.errors);
      throw new Error("Failed to fetch API");
    }
    console.log(json);
    return json;
}
}

export async function getCours({region='national'}) {
  console.log(region)
  if(region !=='national')
    return await getCoursRegion(region)
    const response=await login();
if (response.ok) {
    var data = await response.json();
    console.log(data)
    const res = await fetch("https://altadmin.if-algerie.com/api/content/ifa/cours-francais", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization":"Bearer "+data['access_token']
      },
      
    });

    const json = await res.json();
  
    if (json.errors) {
      console.error(json.errors);
      throw new Error("Failed to fetch API");
    }
    console.log(json);
    return json;
  }
}

export async function getCoursRegion(region,id) {
  console.log(region)
  const response=await login();
if (response.ok) {
  var data = await response.json();
  console.log(data)
  const res = await fetch(`${baseUrl}${coursRoutes.filter(x=>x.region===region)[0].url}${id?'/'+id:''}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization":"Bearer "+data['access_token']
    },
    
  });

  const json = await res.json();

  if (json.errors) {
    console.error(json.errors);
    throw new Error("Failed to fetch API");
  }
  console.log(json);
  return json;
}
}



